<template>
  <div class="col-lg-8 offset-lg-2 page">
    <div class="row">
      <medication-filter :arrayToFilter="allMedications" :type="type"
                        v-on:update-keywords="updateKeywords"
                        v-on:filter-medications="updateFilterResults">

      </medication-filter>

      <medication-sort :arrayToSort="filteredMedications ? filteredMedications : allMedications"
                       v-on:sortArray="updateSortedMedications">

      </medication-sort>
    </div>

    <medication-detail :keywords="keywords"
                       :medications="filteredMedications
                       ? filteredMedications : allMedications">

    </medication-detail>

  </div>
</template>

<script>
  import { getAllMedications } from '@/data/getters.js';
  import { mapGetters } from 'vuex';
  import FilterPage from '../_partials/filter/FilterPage';
  import MedicationDetail from './MedicationDetail';
  import SortPage from '../_partials/sort/SortPage';

  export default {
    name: "medications-page",
    components: {
      'medication-detail': MedicationDetail,
      'medication-filter': FilterPage,
      'medication-sort': SortPage,
    },
    data() {
      return {
        filteredMedications: null,
        keywords: [],
        type: 'MEDICATION',
      }
    },
    computed: {
      ...mapGetters('login', {
        allData: 'getAllData',
      }),
      allMedications: function () {
        return _.orderBy(getAllMedications(this.allData), [(element) => {return element.lo || ''}], 'desc');
      }
    },
    methods: {
      updateFilterResults(data) {
        this.filteredMedications = data;
      },
      updateKeywords(data) {
        this.keywords = data;
      },
      updateSortedMedications(data) {
        this.filteredMedications = data;
      }
    },
  }
</script>

<style scoped lang="scss">
  .page {
    max-width: 800px;
  }
</style>